module.exports = __webpack_public_path__ + "img/wangzhifeng.405d3ed3.jpg";